<template>
  <div :class="['main-content', isLarge ? 'is-large' : 'is-not-large']">
    <router-view></router-view>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Main',
  computed: {
    ...mapGetters({
      isLarge: 'customer/isLarge',
    }),
  },
}
</script>

<style lang='scss'>
.is-large {
  width: 1920px;
}
.is-not-large {
  width: 1280px;
}
.main-content {
  margin: 0 auto;
  padding-bottom: 60px;
}
</style>